import { NextRouter, useRouter } from 'next/router'

interface UseCodeIdReturnType {
  batchId: string
  flowcodeId: string
}

export function useCodeIdFromRouter(): UseCodeIdReturnType {
  const { query } = useRouter()
  return parseCodeIdFromQuery(query)
}

export function parseCodeIdFromQuery(query: NextRouter['query']): UseCodeIdReturnType {
  const flowcodeId = (query.flowcodeId as string) ?? ''
  if (flowcodeId) {
    return {
      flowcodeId,
      batchId: flowcodeId.slice(0, -4)
    }
  }
  const batchId = (query.batchId as string) ?? ''
  return {
    batchId,
    flowcodeId
  }
}
